<template>
  <div
    v-click-outside="hideEmojies"
    class="rich-text-bar">

    <vue-media 
      :query="{maxWidth: 767.98}"
      @media-enter="mediaEnter"
      @media-leave="mediaLeave" />

    <div class="option-placeholders">
      <button
        v-if="emojiesAlowed"
        tabindex="-1"
        @click="showEmojies"
        :class="{
          'emojies': true,
          'close-popup': isEmojiPickerActive
        }">

        <span class="center">
          {{ emojiLabel }}
        </span>

        <div class="rich-editor-container">
          <!-- Might have to do this vv -->
          <component
            v-show="emojiesShown && emojiPickerLoader"
            :is="emojiPickerLoader"
            :showPreview="false"
            :emojiTooltip="false"
            native
            @click="useEmoji"
            :title="$t('Button.pickEmoji')"/>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import Media from 'vue-media'

export default {
  data () {
    return {
      emojies: false,
      selectedEditor: null,
      emojiesAlowed: true
    }
  },

  methods: {
    /**
     * Indicates that we are in mobile view > sm
     */
    mediaEnter () {
      this.$set(this, 'emojiesAlowed', false)
    },

    /**
     * Indicates that we are in desktop view > sm
     */
    mediaLeave () {
      this.$set(this, 'emojiesAlowed', true)
    },

    /**
     * Hides emoji popup
     */
    hideEmojies () {
      this.emojies = false
    },

    /**
     * Shows emoji popup
     */
    showEmojies () {
      if (!this.emojiesAlowed) return false
      this.emojies = true
    },

    /**
     * Emits an event to pick an emoji
     * @param {Object} e
     */
    useEmoji (e) {
      this.$emit('insertEmoji', {emoji: e.native})
    }
  },

  computed: {
    /**
     * Lazy loads emoji picker
     * @returns {Prommise}
     */
    emojiPickerLoader () {
      if (this.ignoreEmojiPromise || !this.emojiesAlowed) return undefined

      // eslint-disable-next-line
      return () => import('emoji-mart-vue').then(({ Picker }) => Picker)
    },

    /**
     * Tells if emoji picker is active
     * @returns {Boolean}
     */
    isEmojiPickerActive () {
      return this.selectedEditor === 'emojies'
    },

    /**
     * Gives a label for emoji picker button
     * @returns {String}
     */
    emojiLabel () {
      if (this.emojiesShown) {
        return '😡'
      }
      else {
        return '😀'
      }
    },

    /**
     * Tells if emoji picker is shown
     * @returns {Boolean}
     */
    emojiesShown () {
      return this.emojies
    }
  },

  props: {
    ignoreEmojiPromise: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    'vue-media': Media
  },

  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-popup {
  background-color: #FE2B41;
  color: #ffffff!important;
}

.rich-text-bar {
  background-color: #ffffff;
  position: absolute!important;
  z-index: 100;
  top: 0!important;
  width: 100%;
}
.ct {
  text-decoration: line-through;
}
.option-placeholders button {
  border: 1px solid #D2D3D4;
  color: #353635;
  border-radius: 4px;
  margin: 5px 0;
  padding: 3px 9px;
  cursor: pointer;
  transition: all .3s;
}
.rich-editor-container {
  position: absolute;
  margin-top: 8px;
  z-index: 100000;
  right: -4px;
}
.option-placeholders button:hover {
  background-color: #353635;
  color: #ffffff;
}

.option-placeholders .emojies {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 100%;
  background-color: transparent;
  border: 0;
  z-index: -1;
  width: 35px;
  height: 35px;
  margin: 0;
}
.option-placeholders .emojies:hover {
  background-color: #35363533;
  color: #353535;
}

.option-placeholders {
  position: absolute;
  top: 0;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/input/RichTextOptions.vue?73f27083